import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Card, Pill, Select } from "../dash/Shell";

const STATUSES = ["pending", "confirmed", "assigned", "completed", "cancelled"];
const tone = { pending: "gold", confirmed: "slate", assigned: "slate", completed: "mint", cancelled: "red" };

export default function AdminBookings({ onChange }) {
  const [rows, setRows] = useState([]);
  const [techs, setTechs] = useState([]);

  const load = () =>
    Promise.all([api.get("/admin/bookings"), api.get("/admin/technicians")]).then(([b, t]) => {
      setRows(b.data);
      setTechs(t.data.filter((x) => x.can_work));
    });
  useEffect(() => { load().catch((e) => toast.error(errMsg(e))); }, []);

  const patch = async (id, body) => {
    try {
      const { data } = await api.patch(`/admin/bookings/${id}`, body);
      setRows((r) => r.map((x) => (x.id === id ? data : x)));
      onChange?.();
    } catch (e) { toast.error(errMsg(e)); }
  };

  const eligible = (b) => techs.filter((t) => t.services.includes(b.service_id));

  return (
    <Card title="Bookings" sub="Assign a technician (only those with that service ON and an active plan are listed) and track status." testid="admin-bookings">
      {rows.length === 0 ? (
        <p data-testid="admin-no-bookings" className="text-slate-400 text-sm">No bookings yet.</p>
      ) : (
        <div className="overflow-x-auto -mx-2">
          <table className="w-full text-sm min-w-[860px]">
            <thead>
              <tr className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-400 text-left">
                <th className="px-2 py-2">ID</th><th className="px-2 py-2">Customer</th><th className="px-2 py-2">Service</th><th className="px-2 py-2">Slot</th><th className="px-2 py-2">Total</th><th className="px-2 py-2">Pay</th><th className="px-2 py-2">Technician</th><th className="px-2 py-2">Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((b) => (
                <tr key={b.id} data-testid={`admin-booking-row-${b.id}`} className="border-t border-white/5 align-top">
                  <td className="px-2 py-3 font-mono text-gold">{b.id}</td>
                  <td className="px-2 py-3"><p className="text-white">{b.name}</p><p className="text-slate-500 text-xs">{b.phone}</p><p className="text-slate-500 text-xs max-w-[200px] truncate">{b.address}</p></td>
                  <td className="px-2 py-3 text-slate-300">{b.service_name.en}</td>
                  <td className="px-2 py-3 text-slate-300 whitespace-nowrap">{b.date}<br /><span className="text-slate-500 text-xs">{b.time}</span></td>
                  <td className="px-2 py-3 text-white">₹{b.total}{b.coupon_code && <p className="text-mint text-[10px] font-mono">{b.coupon_code}</p>}</td>
                  <td className="px-2 py-3"><Pill tone={b.payment_status === "paid" ? "mint" : "gold"}>{b.payment_status}</Pill></td>
                  <td className="px-2 py-3 min-w-[160px]">
                    <Select data-testid={`admin-assign-${b.id}`} value={b.technician_id || ""} onChange={(e) => patch(b.id, { technician_id: e.target.value })} className="py-2">
                      <option value="">— unassigned —</option>
                      {eligible(b).map((t) => <option key={t.user_id} value={t.user_id}>{t.user?.name || t.user_id}</option>)}
                    </Select>
                  </td>
                  <td className="px-2 py-3 min-w-[140px]">
                    <Select data-testid={`admin-status-${b.id}`} value={b.status} onChange={(e) => patch(b.id, { status: e.target.value })} className="py-2">
                      {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                    </Select>
                    <div className="mt-1.5"><Pill tone={tone[b.status]}>{b.status}</Pill></div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
